import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Cheapcabinpune() {



  const cardData = {
"keyword": "Cheap Cabs in Pune",

"headingDescription":
  "Shivai Travels offers affordable and reliable Cheap Cabs in Pune for local travel, airport transfers, outstation trips, corporate rides, family outings, and daily commuting needs. We focus on providing budget-friendly taxi services without compromising on comfort, safety, or service quality. With professional drivers, clean vehicles, transparent pricing, and no hidden charges, we ensure a smooth and economical travel experience across Pune and nearby destinations. Our fleet includes comfortable sedans, spacious SUVs, and premium cars suitable for individuals, families, students, and business travelers. Whether you need a quick city ride, airport taxi, one-way cab, or full-day booking, Shivai Travels provides convenient and low-cost cab services with easy booking and 24/7 customer support.",

"topPlaces": [
  {
    "title": "Affordable Local Cab Service in Pune",
    "description": "Cheap cabs in Pune provide budget-friendly local travel for daily commuting, shopping, office trips, and short city rides without compromising on comfort and safety."
  },
  {
    "title": "Low-Cost Airport Cab Pune",
    "description": "Economical airport cab service in Pune offers affordable pickup and drop options for travelers looking for reliable and budget-friendly airport transfers."
  },
  {
    "title": "Budget Outstation Cabs from Pune",
    "description": "Cheap outstation cabs from Pune cover popular routes like Mumbai, Nashik, Shirdi, and Mahabaleshwar with cost-effective fares and comfortable long-distance travel."
  },
  {
    "title": "Economy One Way Cab Pune",
    "description": "One-way cheap cab service in Pune is ideal for intercity travel without return charges, making it a highly affordable option for solo and family trips."
  },
  {
    "title": "Shared and Budget Taxi Options Pune",
    "description": "Cheap cab options in Pune include economical shared and standard taxi services for passengers looking to reduce travel costs within the city and nearby areas."
  },
  {
    "title": "Hourly Budget Cab Rental Pune",
    "description": "Affordable hourly cab rental in Pune allows flexible travel for multiple stops at low prices, suitable for errands, meetings, and local sightseeing."
  },
  {
    "title": "Student-Friendly Cab Service Pune",
    "description": "Cheap cab services in Pune are ideal for students, offering safe and pocket-friendly rides for college travel, hostel transfers, and daily commuting."
  },
  {
    "title": "Group Budget Travel Cab Pune",
    "description": "Economical group travel cabs in Pune like Ertiga and Innova sharing options help reduce cost per person for family and friends traveling together."
  },
  {
    "title": "24/7 Low Fare Cab Pune",
    "description": "Budget cab service in Pune operates 24/7, ensuring affordable travel anytime for emergency rides, late-night trips, and early morning journeys."
  },
  {
    "title": "Reliable Cheap Taxi Service Pune",
    "description": "Cheap cabs in Pune combine affordability with reliability, offering clean vehicles, trained drivers, and safe travel experiences at reasonable prices."
  }
],



services: [
  {
    name: "Cheap Cabs in Pune",
    description: "Cheap cabs in Pune provide affordable transportation for passengers looking for economical local and outstation travel options. Comfortable vehicles ensure smooth city and highway journeys while maintaining budget-friendly pricing for travelers. Professional drivers ensure safe driving and punctual pickup services across Pune. Pickup services are available from homes, offices, hotels, railway stations, and airport terminals. Flexible booking options allow convenient and cost-effective cab reservations."
  },
  {
    name: "Budget Cab Pune",
    description: "Budget cab Pune service offers economical transportation for daily travel, airport transfers, and outstation journeys within affordable pricing. Comfortable vehicles provide reliable city and highway travel suitable for families, tourists, and business travelers. Professional drivers ensure safe journeys and timely pickup services throughout Pune. Pickup services are available from residential areas, hotels, offices, railway stations, and airports. Flexible booking options allow easy budget cab reservations."
  },
  {
    name: "Low Cost Cab Pune",
    description: "Low cost cab Pune service provides affordable travel solutions for passengers seeking reliable transportation at economical rates. Vehicles offer comfortable seating and smooth travel experience for local and outstation journeys. Professional drivers ensure safe driving and punctual pickup services across Pune city and nearby destinations. Pickup services are available from homes, offices, hotels, railway stations, and airport terminals. Flexible booking options allow convenient low-cost travel planning."
  },
  {
    name: "Affordable Cab Service Pune",
    description: "Affordable cab service Pune offers dependable transportation with comfortable vehicles and economical pricing for local and outstation travel. Vehicles ensure smooth city and highway travel experience suitable for airport transfers, tourism, and business trips. Professional drivers ensure safe journeys and timely pickup services throughout Pune. Pickup services are available from homes, offices, hotels, railway stations, and airports. Flexible booking options allow convenient and affordable cab reservations."
  },
  {
    name: "Cheapest Taxi Pune",
    description: "Cheapest taxi Pune service provides cost-effective transportation for passengers looking for budget-friendly travel options across Pune and nearby destinations. Comfortable vehicles ensure reliable travel experience while maintaining affordable fare structures. Professional drivers ensure punctual pickup and safe transportation services throughout the journey. Pickup services are available from homes, hotels, offices, railway stations, and airport terminals. Flexible booking options allow easy taxi reservations at economical prices."
  },
  {
    name: "Discount Cab Pune",
    description: "Discount cab Pune service offers affordable transportation with economical pricing for local travel, airport transfers, and outstation journeys. Comfortable vehicles provide smooth travel experience suitable for daily commuters, tourists, and corporate travelers. Professional drivers ensure safe driving and punctual pickup services across Pune. Pickup services are available from homes, offices, hotels, railway stations, and airport terminals. Flexible booking options allow convenient discounted cab reservations."
  },
  {
    name: "Economy Cab Pune",
    description: "Economy cab Pune service provides reliable and affordable transportation for passengers traveling within Pune and nearby cities. Vehicles ensure comfortable seating and smooth city travel suitable for daily commutes, family trips, and airport transfers. Professional drivers ensure safe journeys and timely pickup services throughout Pune. Pickup services are available across residential areas, offices, hotels, railway stations, and airports. Flexible booking options allow convenient economy cab reservations."
  },
  {
    name: "Low Fare Taxi Pune",
    description: "Low fare taxi Pune service offers economical transportation for local and outstation travel with budget-friendly pricing options. Comfortable vehicles provide reliable travel experience for airport transfers, office commutes, and tourism trips. Professional drivers ensure safe driving and punctual pickup services across Pune city and nearby destinations. Pickup services are available from homes, hotels, offices, railway stations, and airports. Flexible booking options allow convenient low-fare taxi reservations."
  },
  {
    name: "Cheap Outstation Cab Pune",
    description: "Cheap outstation cab Pune service provides affordable long-distance transportation for travelers planning intercity journeys from Pune. Vehicles include sedans, SUVs, and premium taxis suitable for comfortable highway travel at economical pricing. Professional drivers ensure safe driving and smooth travel experience throughout the journey. Pickup services are available across Pune including homes, offices, hotels, railway stations, and airport terminals. Flexible booking options allow convenient outstation cab reservations."
  },
  {
    name: "Budget Taxi Pune",
    description: "Budget taxi Pune service offers affordable transportation for city travel, airport transfers, and nearby destination trips. Comfortable vehicles provide reliable travel experience suitable for individuals, families, and business travelers. Professional drivers ensure punctual pickup and safe transportation services throughout Pune. Pickup services are available from homes, offices, hotels, railway stations, and airport terminals. Flexible booking options allow convenient budget taxi reservations."
  },
  {
    name: "Best Price Cab Pune",
    description: "Best price cab Pune service provides comfortable transportation with competitive pricing for local and outstation travel. Vehicles ensure smooth city and highway journeys suitable for airport transfers, tourism, and family travel needs. Professional drivers ensure safe driving and timely pickup services across Pune. Pickup services are available from homes, offices, hotels, railway stations, and airport terminals. Flexible booking options allow convenient and value-for-money cab reservations."
  },
  {
    name: "Cab Offers Pune",
    description: "Cab offers Pune service provides economical travel solutions for passengers looking for affordable transportation options across Pune. Comfortable vehicles ensure reliable city and highway travel experience suitable for local trips, airport rides, and outstation journeys. Professional drivers ensure safe transportation and punctual pickup services. Pickup services are available from homes, hotels, offices, railway stations, and airport terminals. Flexible booking options allow convenient cab reservations with affordable pricing."
  },
  {
    name: "Economical Cab Pune",
    description: "Economical cab Pune service offers budget-friendly transportation for passengers traveling within Pune and nearby destinations. Comfortable vehicles provide smooth travel experience while maintaining affordable fare options for passengers. Professional drivers ensure safe journeys and punctual pickup services throughout Pune. Pickup services are available from residential areas, offices, hotels, railway stations, and airports. Flexible booking options allow convenient economical cab reservations."
  },
  {
    name: "Cab Deals Pune",
    description: "Cab deals Pune service provides affordable transportation options for local travel, airport transfers, and outstation journeys. Comfortable vehicles ensure reliable travel experience suitable for families, tourists, and business travelers. Professional drivers ensure safe driving and timely pickup services across Pune and nearby destinations. Pickup services are available from homes, offices, hotels, railway stations, and airport terminals. Flexible booking options allow convenient and budget-friendly cab reservations."
  },
  {
    name: "Affordable Outstation Cab Pune",
    description: "Affordable outstation cab Pune service provides economical long-distance transportation for travelers planning journeys from Pune to various destinations. Vehicles include sedans, SUVs, and premium taxis suitable for comfortable highway travel. Professional drivers ensure safe driving and punctual pickup services throughout the journey. Pickup services are available from homes, hotels, offices, railway stations, and airport terminals across Pune. Flexible booking options allow convenient and affordable outstation cab reservations."
  },
  {
    name: "Cheap Pune to Mumbai Cab",
    description: "Cheap Pune to Mumbai cab service provides affordable transportation between Pune and Mumbai with comfortable vehicles and experienced drivers. Vehicles are suitable for expressway travel ensuring smooth and reliable journeys for passengers. Pickup services are available from homes, offices, hotels, railway stations, and airport terminals across Pune and Mumbai. Ideal for business travel, airport transfers, tourism, and family visits. Flexible booking options allow convenient one-way and round-trip travel reservations."
  }
],

tableData: [
  ["Cheap Cabs in Pune", "Budget Cab Pune"],
  ["Low Cost Cab Pune", "Affordable Cab Service Pune"],
  ["Cheapest Taxi Pune", "Discount Cab Pune"],
  ["Economy Cab Pune", "Low Fare Taxi Pune"],
  ["Cheap Outstation Cab Pune", "Budget Taxi Pune"],
  ["Best Price Cab Pune", "Cab Offers Pune"],
  ["Economical Cab Pune", "Cab Deals Pune"],
  ["Affordable Outstation Cab Pune", "Cheap Pune to Mumbai Cab"]
],



 whychoose: [
      {
        WhyChooseheading: "Affordable Cab Service in Pune",
        WhyChoosedescription: "Shivai Travels provides cheap cabs in Pune with budget-friendly pricing for local travel, airport transfers, and outstation trips. Customers receive affordable taxi solutions without compromising travel comfort."
      },
      {
        WhyChooseheading: "Transparent & Budget-Friendly Pricing",
        WhyChoosedescription: "Shivai Travels offers transparent fare details with no hidden charges for cheap cab service in Pune. Customers can book economical taxi rides with clear pricing before confirming the trip."
      },
      {
        WhyChooseheading: "24/7 Cheap Cab Availability",
        WhyChoosedescription: "Our cheap cab service in Pune operates 24 hours a day for airport pickup, railway station transfers, office travel, emergency transportation, and outstation journeys."
      },
      {
        WhyChooseheading: "Clean & Comfortable AC Cabs",
        WhyChoosedescription: "Even with affordable pricing, Shivai Travels maintains clean, sanitized, and fully air-conditioned taxis to provide comfortable travel experiences for passengers."
      },
      {
        WhyChooseheading: "Local & Outstation Budget Taxi Service",
        WhyChoosedescription: "Shivai Travels provides cheap cabs in Pune for local city rides, one-way outstation trips, round-trip taxi bookings, airport transfers, and customized travel requirements."
      },
      {
        WhyChooseheading: "Multiple Vehicle Options for Every Budget",
        WhyChoosedescription: "Customers can choose from budget-friendly sedan taxis, Ertiga, Innova, and larger vehicles like Tempo Travellers depending on passenger count and travel needs."
      },
      {
        WhyChooseheading: "Doorstep Pickup Across Pune",
        WhyChoosedescription: "Shivai Travels provides convenient pickup services from homes, offices, hotels, Pune Airport, railway stations, and major Pune areas including Baner, Wakad, Kharadi, Hinjewadi, and Hadapsar."
      },
      {
        WhyChooseheading: "Reliable Cheap Taxi Service in Pune",
        WhyChoosedescription: "Shivai Travels is trusted for reliable cheap cab service in Pune with punctual drivers, affordable fares, comfortable vehicles, and smooth transportation for daily and outstation travel."
      }
    ]
  };

  const faqData = [
    { question: "Are cheap cabs available in Pune?", answer: "Yes, Shivai Travels provides affordable and cheap cab services in Pune for local and outstation travel." },
    { question: "Is cheap cab service available 24 hours?", answer: "Yes, Shivai Travels offers 24/7 cheap cab service in Pune." },
    { question: "Which vehicles are available for cheap cab booking?", answer: "Shivai Travels offers sedan taxis, Ertiga, Innova, and Tempo Travellers for budget-friendly travel." },
    { question: "Can I book one-way cheap cabs from Pune?", answer: "Yes, customers can book one-way as well as round-trip cheap cab services from Pune." },
    { question: "Do you provide cheap airport taxi service in Pune?", answer: "Yes, Shivai Travels provides affordable airport pickup and drop taxi services in Pune." },
    { question: "Are all cheap taxis air-conditioned?", answer: "Yes, all taxis are fully air-conditioned and maintained for comfortable travel." },
    { question: "Can I book cheap cabs online?", answer: "Yes, customers can easily book cheap cabs in Pune online or through phone booking." },
    { question: "Do you provide cheap cabs for family trips?", answer: "Yes, Shivai Travels provides affordable cab options for family tours, vacations, and group travel." },
    { question: "Are there any hidden charges in cab fares?", answer: "No, Shivai Travels provides transparent pricing without hidden charges." },
    { question: "Is advance booking available for cheap cabs?", answer: "Yes, advance booking is available and recommended during weekends and peak travel seasons." }
  ];

  const testimonials = [
    {
      id: 1,
      name: "Mr. Rahul Chavan",
      feedback:
        "I Booked a cheap cab in Pune from Shivai Travels. Affordable fare, clean vehicle, and excellent driver service.",
      rating: 5
    },
    {
      id: 2,
      name: "Mrs. Anjali Patil",
      feedback:
        "Very good budget taxi service in Pune. On-time pickup, comfortable cab, and transparent pricing.",
      rating: 5
    }
  ];










































  const Images = [
    { place: "/images/keyword/1.jpg", text: "Pune Outstation Cab Service", link: "Pune-Outstation-Cab-Service" },
    { place: "/images/keyword/2.jpg", text: "Pune Taxi Service", link: "Pune-Taxi-Service" },
    { place: "/images/keyword/3.jpg", text: "Pune Cab Booking", link: "Pune-Cab-Booking" },
    { place: "/images/keyword/4.jpg", text: "Best Cab Service in Pune", link: "Best-Cab-Service-in-Pune" },
    { place: "/images/keyword/5.jpg", text: "Outstation Taxi Service Pune", link: "Outstation-Taxi-Service-Pune" },
    { place: "/images/keyword/6.jpg", text: "Cheap Cabs in Pune", link: "Cheap-Cabs-in-Pune" },
    { place: "/images/keyword/7.jpg", text: "Pune Cab Fare", link: "Pune-Cab-Fare" },
    { place: "/images/keyword/8.jpg", text: "Corporate Cab Service Pune", link: "Corporate-Cab-Service-Pune" },
    { place: "/images/keyword/9.jpg", text: "Pune Airport Cab", link: "Pune-Airport-Cab" },
    { place: "/images/keyword/10.jpg", text: "Pune Railway Station Cab Service", link: "Pune-Railway-Station-Cab-Service" },
    { place: "/images/keyword/11.jpg", text: "Pune One Way Cab Service", link: "Pune-One-Way-Cab-Service" },
    { place: "/images/keyword/12.jpg", text: "Pune Local and Outstation Cab", link: "Pune-Local-and-Outstation-Cab" },
    { place: "/images/keyword/13.jpg", text: "Pune to Mumbai Cab", link: "Pune-to-Mumbai-Cab" },
    { place: "/images/keyword/14.jpg", text: "Pune to Mumbai Airport Cab", link: "Pune-to-Mumbai-Airport-Cab" },
    { place: "/images/keyword/15.jpg", text: "Pune to Nashik Cab Service", link: "Pune-to-Nashik-Cab-Service" },
    { place: "/images/keyword/16.jpg", text: "Pune to Nagpur Cab", link: "Pune-to-Nagpur-Cab" },
    { place: "/images/keyword/17.jpg", text: "Pune to Kolhapur Cab", link: "Pune-to-Kolhapur-Cab" },
    { place: "/images/keyword/18.jpg", text: "Pune to Solapur Cab Service", link: "Pune-to-Solapur-Cab-Service" },
    { place: "/images/keyword/19.jpg", text: "Pune to Ahmednagar Taxi", link: "Pune-to-Ahmednagar-Taxi" },
    { place: "/images/keyword/20.jpg", text: "Pune to Sangli Cab", link: "Pune-to-Sangli-Cab" },
    { place: "/images/keyword/21.jpg", text: "Pune to Satara Cab Service", link: "Pune-to-Satara-Cab-Service" },
    { place: "/images/keyword/22.jpg", text: "Pune to Jalgaon Cab Service", link: "Pune-to-Jalgaon-Cab-Service" },
    { place: "/images/keyword/23.jpg", text: "Pune to Dhule Cab Service", link: "Pune-to-Dhule-Cab-Service" },
    { place: "/images/keyword/24.jpg", text: "Pune to Thane Cab", link: "Pune-to-Thane-Cab" },
    { place: "/images/keyword/25.jpg", text: "Pune to Panvel Cab", link: "Pune-to-Panvel-Cab" },

  ];









const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Cheap Cabs in Pune",
  "image": "https://shivaitravels.com/assets/images/cheap-cabs-pune.jpg",
  "description": "Book cheap cabs in Pune with Shivai Travels for local and outstation travel. Affordable taxi services, budget cabs, low fare airport taxis, and economical Pune to Mumbai cab booking available 24x7.",
  "brand": {
    "@type": "Brand",
    "name": "Shivai Travels"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.8",
    "ratingCount": "5471"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "On Request",
    "availability": "https://schema.org/InStock",
    "url": "https://shivaitravels.com/cheap-cabs-in-pune"
  }
};







  return (
    <div>



<Helmet>
  <title>Cheap Cabs in Pune | Affordable & Budget Taxi Service | +91 9689815477</title>

  <meta
    name="description"
    content="Book cheap cabs in Pune for local and outstation travel. Affordable taxi service, low fare airport cabs, budget Pune to Mumbai taxi booking, and economical AC cab service available 24x7."
  />

  <meta
    name="keywords"
    content="Cheap cabs in pune, budget cab pune, low cost cab pune, affordable cab service pune, cheapest taxi pune, discount cab pune, economy cab pune, low fare taxi pune, cheap outstation cab pune, budget taxi pune, best price cab pune, cab offers pune, economical cab pune, cab deals pune, affordable outstation cab pune, Cheap cab service in pune, Cheap cab service pune, Pune to mumbai cheap cabs, cheapest cab service in Pimpri Chinchwad, Low price taxi service Pimpri Chinchwad"
  />

  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>


      <div className="breadcrumb-bar">
        <div className="container">
          <div className="row align-items-center text-center">
            <div className="col-md-12 col-12">
              <h2 className="breadcrumb-title text-white"> {cardData.keyword}</h2>

            </div>
          </div>
        </div>
      </div>













      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/6.jpg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#3F1B0D', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >Shivai Travels: {cardData.keyword} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">

                <p className="sectionLead">Top Places to visit from {cardData.keyword} </p>
                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard borderr" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>

                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>


              <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div key={index} className="service-row">
                    {/* <div className="service-icon">
                      🚗
                    </div> */}
                    <div>
                      <h4 className="service-title">{service.name}</h4>
                      <p className="service-desc">{service.description}</p>
                    </div>
                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable />

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Shivai Travels</span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Shivai Travels </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase keyword={cardData.keyword} />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
                <h4 className="pc-title">Contact Information</h4>

                <div className="pc-grid">
                  {/* Phones */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-telephone-fill"></i>
                      <span>Phone Numbers</span>
                    </header>

                    <div className="pc-list">
                      <a href="tel:+919689815477" className="pc-call">+91 9689815477</a>
                    </div>

                    <div className="pc-cta">
                    <a
  href="https://wa.me/919689815477?text=Welcome%20to%20Shivai%20Travels!%20%F0%9F%9A%8C%0AWe%20are%20happy%20to%20assist%20you%20with%20comfortable%20and%20safe%20travel%20services.%20Please%20let%20us%20know%20how%20we%20can%20help%20you."
  target="_blank"
  rel="noopener noreferrer"
  className="pc-whats"
>
  <i className="bi bi-whatsapp"></i> WhatsApp
</a>
                      <a href="tel:+919689815477" className="pc-primary">
                        Call Now
                      </a>
                    </div>
                  </section>

                  {/* Email */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-envelope-fill"></i>
                      <span>Email</span>
                    </header>

                    <a href="mailto:booking@shivaitravels.com" className="pc-email">
                      booking@shivaitravels.com
                    </a>
                  </section>

                  {/* Address */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-geo-alt-fill"></i>
                      <span>Address</span>
                    </header>

                    <address className="pc-address">
                      <strong>Shivai Travels</strong><br />
                      Shop no 1, Kamdhenu nagar, Guru mauli society, Vadgaon road, Near super bazar, Alandi, Pune 412105
                    </address>
                  </section>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Cheapcabinpune;